import { atom } from 'jotai'
import { getSubgraphUrl } from 'services/query/hooks'
import { convertAmountToWei } from 'utils'
import { UndefinedCoingeckoId, UnsupportedCurrencyError } from 'utils/errors'
import { createAtomsWithQuery } from '../atomic-factory'
import { QUERY_KEY_PRICE } from '../keys'
import { DEFAULT_REFETCH_INTERVAL } from '../refetch-intervals'
import {
  PriceRequest,
  PriceRequestAtoms,
  PriceResponse,
  defaultPriceRequest,
  getCoinGeckoPrice,
  parsePrice,
} from './model'
import { getParamsForIndexPrice } from './query-params'

export type RawIndexPriceResponse = {
  indexes: RawProductPriceResponse[]
}

export type RawProductPriceResponse = {
  basePrice: string
}

export const getIndexPriceParams = (address: string) => ({
  url: getSubgraphUrl(address),
  params: getParamsForIndexPrice(address),
})

export const outputIndexV1Query = async <T>({
  queryKey: [, _params],
}: {
  queryKey: (string | PriceRequest)[]
}) => {
  const params = _params as PriceRequest

  if (params.sellCurrency.coingeckoId === undefined) {
    throw new UndefinedCoingeckoId(params.sellCurrency)
  }
  if (params.sellCurrency.type !== 'index-v1')
    throw new UnsupportedCurrencyError(params.sellCurrency.type)

  const price = await getCoinGeckoPrice(params.sellCurrency.coingeckoId)

  const productPrice = convertAmountToWei(price, params.sellCurrency.decimals)

  return parsePrice(
    {
      result: BigInt(productPrice.toFixed()),
      status: 'success',
    },
    {
      result: params.sellCurrency.decimals,
      status: 'success',
    },
    params,
  ) as T
}

export const priceIndexV1Factory = () => {
  const priceRequestParamsAtom = atom<PriceRequest>(defaultPriceRequest)

  const mainProperties = createAtomsWithQuery<
    PriceResponse,
    PriceRequest,
    null,
    null,
    [string, PriceRequest]
  >(
    { first: priceRequestParamsAtom },
    QUERY_KEY_PRICE,
    outputIndexV1Query<PriceResponse>,
    DEFAULT_REFETCH_INTERVAL,
    'outputIndexV1Query',
  )

  return { params: priceRequestParamsAtom, ...mainProperties } as PriceRequestAtoms
}
